var BlockView = require('views/block/base-block-view');
var ActionPlanTopicResponsesCollectionView = require('views/block/action-plan-responses/action-plan-topic-responses-collection-view');
import { SessionStorageService } from 'services/web-storage-service';
var LocaleService = require('services/locale-service');

var ActionPlanResponsesView = BlockView.extend({
  regions: {
    'actionPlanResponses': '#action-plan-responses'
  },

  load: function() {
    var self = this, moduleKey = SessionStorageService.getItem('queryParams').key || EF.module.get('key');
    this.model.set('moduleKey', moduleKey);
    EF.actionPlanTopics.fetchWithResponses(moduleKey).done(function() {
      self.bindView();
    });
  },

  bindView: function() {
    this.setResponses();
    this.setViewState();
    var self = this;
    self.collection = EF.actionPlanTopics;
    var actionPlanTopicResponsesCollectionView = new ActionPlanTopicResponsesCollectionView({
      collection: self.collection,
      region: 'actionPlanResponses',
      model: self.model
    });
    self.subview('actionPlanResponses', actionPlanTopicResponsesCollectionView);
    Chaplin.mediator.publish('block:action-plan-responses:rendered', self.collection);
    self.$el.find('#action-plan-responses a#close').attr('tabindex', 0).focus();
    setTimeout(function() {
      
      var notCompleteElem = self.$el.find('#responses-incomplete');
      if(notCompleteElem.css('display') == 'none') {
        self.$el.find('#action-plan-responses').attr('tabindex', '0').focus();
      } else {
        notCompleteElem.children('p').attr('tabindex', '0').focus();
      }
    }, 500);
  },

  setViewState: function() {
    var module = EF.modules.find({ key: this.model.get('moduleKey') });
    this.model.set('moduleTitle', module ? module.get('title') : 'title error');
    this.render();
  },

  setActionPlanItemsCollection: function(actionPlanTopic) {
    var actionPlanItemsCollection = actionPlanTopic.get('action_plan_items_collection');
    if(!actionPlanItemsCollection) {
      var actionPlanItems = actionPlanTopic.get('action_plan_items');
      actionPlanItemsCollection = new EF.Collections.ActionPlanItemsCollection(actionPlanItems, { enrollment: EF.enrollment });
      actionPlanTopic.set('action_plan_items_collection', actionPlanItemsCollection);
      actionPlanTopic.set('anyActionPlanItems', actionPlanItems.length > 0);
    }
    return actionPlanItemsCollection;
  },

  setResponses: function() {
    var self = this, responses = EF.actionPlanTopics.actionPlanItemResponses;
    var doneTotal = 0, responseTotal = 0, actionPlanItemsTotal = 0;
    EF.actionPlanTopics.forEach(function(actionPlanTopic) {
      var actionPlanItemsCollection = self.setActionPlanItemsCollection(actionPlanTopic);
      actionPlanItemsTotal += actionPlanItemsCollection.length;
      var responseCount = 0;
      actionPlanItemsCollection.forEach(function(actionPlanItem) {
        var actionPlanItemResponse = responses.find({ action_plan_item_id: actionPlanItem.get('id') });
        if(actionPlanItemResponse) {
          actionPlanItem.set('actionPlanItemResponse', actionPlanItemResponse);
          actionPlanItemResponse.set(actionPlanItemResponse.get('state'), true);
          responseCount += 1;
          if(actionPlanItemResponse.get('done')) doneTotal += 1;
        }
      });
      actionPlanTopic.set('response_count', responseCount);
      responseTotal += responseCount;
      actionPlanTopic.set('anyActionPlanItemResponses', responseCount > 0);
    });
    this.model.set('stepsComplete', LocaleService.t('actionPlanResponses.stepsComplete', { doneTotal: doneTotal, responseTotal: responseTotal }));
    this.model.set('doneTotal', doneTotal);
    this.model.set('responseTotal', responseTotal);
    this.model.set('actionPlanItemsTotal', actionPlanItemsTotal);
  },

  play: function() {
    var self = this;
    this.delegate('click', '.action-plan-item .response-state-link', function(e) {
      var $link = $(e.currentTarget);
      var responseId = $link.closest('.action-plan-item').data('response-id');
      var actionPlanItemResponse = EF.actionPlanTopics.actionPlanItemResponses.find({ id: responseId });
      actionPlanItemResponse.set(actionPlanItemResponse.get('state'), false);
      actionPlanItemResponse.set('state', $link.data('state'));
      actionPlanItemResponse.save().done(function() {
        self.bindView();
      });
      Chaplin.mediator.publish('block:action-plan-responses:done', e);
      return false;
    });
  }

});

module.exports = ActionPlanResponsesView;
